import React from 'react';
import { StyleSheet, View } from 'react-native';

import { type CloudinaryTransformConfig, getCloudinaryUrl, Image } from '@sg/garnish';

import { GenericImage } from './assets';

// ─────────────────────────────────────────────────────────────────────────────

export const CustomizationFooterImage = (props: Props) => {
  const { url, alt } = props;

  const formattedUrl = url ? getCloudinaryUrl(url, IMAGE_TRANSFORM_CONFIG) : GenericImage;

  return (
    <View style={styles.container}>
      <Image
        source={formattedUrl}
        style={styles.image}
        contentFit="contain"
        alt={alt}
        pointerEvents="none"
      />
    </View>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const IMAGE_SIZE = 196;

const IMAGE_TRANSFORM_CONFIG: CloudinaryTransformConfig = [
  { crop: 'crop', height: 0.66, width: 0.4 },
  { width: IMAGE_SIZE },
];

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    width: IMAGE_SIZE * 0.55,
  },
  image: {
    position: 'absolute',
    left: -IMAGE_SIZE * 0.2,
    bottom: -IMAGE_SIZE * 0.3,
    width: IMAGE_SIZE,
    height: IMAGE_SIZE,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  url: string | undefined;
  alt: string | undefined;
};
